export enum HsaMccReview {
  NotNeeded = "not_needed",
  Pending = "pending",
  Resolved = "resolved",
}
